import { Component } from '@angular/core';
import { Modal } from '@shared/modal/models/modal.model';

export interface ConfirmModalParams {
  title: string;
  message: string;
  confirmType: ConfirmType;
  cancelButton: string;
  confirmButton: string;
  closeButton: boolean;
  hideCloseButton: boolean;
}

export enum ConfirmType {
  INFO,
  ERROR,
  WARNING
}

export enum Answer {
  TRUE,
  FALSE,
  CLOSE
}

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
  standalone: false
})
export class ConfirmModalComponent extends Modal {
  public confirmEnum = ConfirmType;
  public answerEnum = Answer;
  public params: ConfirmModalParams;

  onInjectInputs(params: ConfirmModalParams): void {
    this.params = params;
  }

  answer(result: Answer): void {
    this.close(result);
  }

  cancel(): void {
    this.close(false);
  }
}
